<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>位置：</el-breadcrumb-item>
      <el-breadcrumb-item>视频列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox">
      <div class="conentRow">
        <div>
          <el-input v-model="searchData.videoName" placeholder="视频名称" clearable />
          <el-select v-model="searchData.videoType" placeholder="全部分类" clearable>
            <el-option
              v-for="item in videoTypeOption"
              :key="item.type"
              :label="item.type"
              :value="item.type"
            ></el-option>
          </el-select>
          <el-button type="primary" @click="searchFn">查询</el-button>
        </div>
      </div>
    </el-card>
    <div class="videoBox">
      <div class="videoContent" v-for="v in videoListData" @click="watchVideo(v)" :key="v.videoid">
        <div>
          <img :src="v.pictureurl" alt />
        </div>
        <div>
          <div>{{ v.videoname }}</div>
          <div>{{ v.videokey }}</div>
          <div>{{ v.type }}</div>
        </div>
      </div>
    </div>
    <div class="pagination">
      <span class="demonstration">共{{ total }}条记录，</span>
      <span class="demonstration">当前显示第{{ videoListPar.page }}页</span>
      <el-pagination background layout="prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="videoTitle"
      :visible.sync="videoFlow"
      :before-close="videoClose"
      width="32%"
      center
    >
      <el-divider></el-divider>
      <video :src="videoUrl" width="100%" controls="controls" ref="vueRef"></video>
    </el-dialog>
  </div>
</template>

<script>
import { scenicGetVideoConfigList, scenicGetVideoInfo, scenicVideoTypeList } from '@/request/scenic.js'

export default {
  data() {
    return {
      videoTitle: '',
      videoUrl: '',
      videoFlow: false,
      videoListPar: {
        token: '',
        video_name: '',
        type: '',
        page: 1,
        page_size: 10
      },
      videoListData: [],
      searchData: {
        videoName: '',
        videoType: ''
      },
      videoTypeOption: [],
      total: 0
    }
  },
  mounted() {
    const token = window.sessionStorage.getItem('Token')
    this.videoListPar.token = token
    this.getList()
    this.getSelect()
  },
  methods: {
    videoClose() {
      this.videoUrl = ''
      this.videoFlow = false
    },
    watchVideo(v) {
      scenicGetVideoInfo({
        token: this.videoListPar.token,
        videoid: v.videoid
      }).then(res => {
        if (res.data && res.data.status === 'ok' && res.data.result) {
          const info = res.data.result
          this.videoFlow = true
          this.videoTitle = info.videoname
          this.videoUrl = info.videourl
        }
      })
    },
    getList() {
      scenicGetVideoConfigList(this.videoListPar).then(res => {
        if (res.data && res.data.status === 'ok' && res.data.result) {
          this.videoListData = res.data.result.data || []
          this.total = res.data.result.total || 0
        }
      })
    },
    searchFn() {
      this.videoListPar.page = 1
      this.videoListPar.video_name = this.searchData.videoName
      this.videoListPar.type = this.searchData.videoType
      this.getList()
    },
    getSelect() {
      scenicVideoTypeList({ token: this.videoListPar.token }).then(res => {
        if (res.data && (res.data.status === 'ok' || res.data.rcode == 200)) {
          this.videoTypeOption = res.data.result || []
        }
      })
    },
    handleCurrentChange(val) {
      this.videoListPar.page = val
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
.conentBox {
  margin-top: 17px;
  /deep/.el-card__body {
    padding: 0 0 0 20px;
  }
  .conentRow {
    margin: 20px 0 0 0;
    .el-input {
      width: 240px;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .el-select {
      width: 260px;
      margin-bottom: 20px;
      margin-right: 20px;
    }
    .el-button {
      width: 100px;
      margin-bottom: 20px;
      background: #246deb;
      border-radius: 4px;
      border: none;
    }
  }
}
.videoBox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  cursor: pointer;
  gap: 20px;
  .videoContent {
    width: calc((100% - 80px) / 5);
    margin-bottom: 0;
    > div:nth-child(1) {
      width: 100%;
      height: 17.4rem;
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
    }
    > div:nth-child(2) {
      width: 100%;
      min-height: 14.3rem;
      height: auto;
      padding: 20px;
      box-sizing: border-box;
      background: white;
      border-radius: 0 0 4px 4px;
      > div:nth-child(1) {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        color: #000000;
      }
      > div:nth-child(2) {
        margin: 14px 0;
        font-size: 14px;
        line-height: 20px;
        color: #000000;
      }
      > div:nth-child(3) {
        font-size: 14px;
        line-height: 20px;
        color: #666666;
      }
    }
  }
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 10px auto;
  span {
    font-size: 14px;
    color: #000000;
  }
}
</style>
